import { useMemo } from 'react';

import type { ViewerMode } from 'constants/all';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { useFeatureFlagValue } from 'store/session/hooks';

import { VIEWER_ACCOUNTS, type ViewerAccess } from './access';

/**
 * Builds the `ViewerAccess` contract for a host composition root, from the
 * part relationship the host knows and the signed-in user's active account.
 * Viewer code reads the contract with `useViewerAccess()` instead.
 */
export const useHostViewerAccess = (relationship: ViewerMode): ViewerAccess => {
  // No quoting tool is what makes an account a Part Viewer account (the same
  // flag NavDropDown uses); a change to the flag's meaning changes this too.
  const isQuotingToolAvailable = useFeatureFlagValue(
    featureFlagKeys.isQuotingToolAvailable,
  );
  return useMemo(
    () => ({
      relationship,
      account: isQuotingToolAvailable
        ? VIEWER_ACCOUNTS.QUOTING
        : VIEWER_ACCOUNTS.PART_VIEWER,
    }),
    [relationship, isQuotingToolAvailable],
  );
};
